<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <div class="shield" :class="large ? 'shield--large' : 'shield--small'">
    <v-lazy-image
      :alt="altTitle"
      :src="src"
      :src-placeholder="srcPlaceholder" />
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";

.shield {
  min-width: $shield-size;
  width: $shield-size;
  height: $shield-height;

  &--large {
    min-width: $shield-large-size;
    width: $shield-large-size;
    height: $shield-large-height;
  }

  img {
    width: 100%;
    height: auto;
  }
}
</style>

<script>
import VLazyImage from 'v-lazy-image'
import { mapGetters } from 'vuex'

export default {
  components: {
    VLazyImage
  },

  props: {
    municipality: Number,
    county: Number,
    title: String,
    large: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    srcPlaceholder () {
      return require('../assets/logo.svg')
    },

    altTitle () {
      if (this.municipality && this.municipality > 0) {
        return `Kommunevåpen for ${this.title}`
      }

      return `Fylkesvåpen for ${this.title}`
    },

    src () {
      try {
        const filename = this.filename

        return require(`../assets/shields/${filename}`)
      } catch (e) {
        return this.srcPlaceholder
      }
    },

    filename () {
      /* eslint-disable camelcase */
      /*
      return this.municipality && this.municipality > 0
        ? `kommune-${this.municipality}.svg`
        : `fylke-${this.county}.svg`
        */

      const moves = this.allMovements

      if (this.municipality && this.municipality > 0) {
        const moved = moves.find(m => m.id === this.municipality && (m.legacy_id > 0 || m.merged_legacy_ids.length > 0))
        const id = (moved ? moved.legacy_id : this.municipality) || this.municipality

        return `kommune-${id}.svg`
      }

      const moved = moves.find(m => m.id === this.county && m.merged_legacy_ids.length > 0)
      const id = moved ? moved.merged_legacy_ids[0] : this.county

      return `fylke-${id}.svg`
    },

    ...mapGetters([
      'allMovements'
    ])
  }
}
</script>
